import React from "react";
import { getJwpSignedUrl } from "./getJwpSignedUrl";
import { Trans, withTranslation } from "react-i18next";
// import VideoJs from "./VideoJs";
import { connect } from "react-redux";
import { CPWebVideoJsPlayer } from "cp-web-videojs-player";
import styles from "./videojs.module.css";

// const ERROR_MESSAGE =
//   "It takes several minutes to process a video, please try after some time";

class Player extends React.Component {
  state = {
    loading: true,
    error: null,

    viewsCount: 0,
    seekDuration: 0,
    maxDuration: 0,
    playbackSpeed: 0,
    prevSeekDuration: 2,
    currentSeekDuration: 0,

    lastSeek: null,
    currentTime: null,
    delta: 0,
    duration: 0,
    ERROR_MESSAGE: this?.props?.t(
      "src.components.ReactPlayer.Player.errorMessage",
      "It takes several minutes to process a video, please try after some time"
    ),
  };

  startTimer = null;
  player = null;
  pollInterval = null;

  componentDidMount() {
    const { item, hashKey } = this.props;

    this.setState({ loading: false });
    this.setupBeforeUnloadListener();
    console.log(this);
    this.getVideoLink(item, hashKey, this);
  }

  setupBeforeUnloadListener = () => {
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();

      //this.playerClose();
    });
  };

  updateVideoDetails = (activityType, duration) => {
    const { item, courseId, isExhaustedDisabled } = this.props;
    const body = {
      courseId: courseId,
      contentId: item.id,
      contentType: 2,
      activityType: activityType,
      duration: Math.floor(duration * 1000),
      //duration: this.pollIntervalDuration(),
      lastSeek: Math.floor(this.state.currentTime * 1000),
    };
    if (isExhaustedDisabled) {
      return;
    }
  };

  pollIntervalDuration = () => {
    // let playbackSpeed = this.player.getConfig().playbackRate;
    let playbackSpeed = this.player.playbackRate;
    if (playbackSpeed == 1) return 10000;
    else if (playbackSpeed == 1.25) return 8000;
    else if (playbackSpeed == 1.5) return 6666;
    else if (playbackSpeed == 2) return 5000;
    return 10000;
  };

  onPlay = (key) => {
    const player = this.player;

    // this.startTimer = setTimeout(() => {
    //   this.updateVideoDetails("count", 5);
    // }, 5000);
    this.setState({ start: Date.now(), lastSeek: 0 });

    this.pollInterval = setInterval(() => {
      this.setState(
        (prevState) => {
          return {
            duration:
              prevState.currentTime - prevState.lastSeek + prevState.delta,
          };
        },
        () => {
          //	console.log("Updating duration on server", this.state.duration, (Date.now()/1000)%100);
          //this.updateVideoDetails("view",this.state.duration)
        }
      );
    }, this.pollIntervalDuration());

    const seekTime = this.props.item.lastSeek / 1000;
    this.player && this.player.currentTime(seekTime);
  };

  onPause = (key) => {
    clearTimeout(this.startTimer);
    clearInterval(this.pollInterval);
    this.setState(
      (prevState) => {
        return {
          duration:
            prevState.currentTime - prevState.lastSeek + prevState.delta,
        };
      },
      () => {
        //	console.log("Updating duration on server", this.state.duration);
        //	 this.updateVideoDetails("view",this.state.duration)
      }
    );
    this.startTimer = null;
    this.pollInterval = null;
  };

  onResume = (key) => {
    if (this.pollInterval || this.startTimer) {
      return;
    }
    //	console.log("resumed", this.pollInterval, this.startTimer);
    // if (this.state.duration < 5) {
    //   this.startTimer = setTimeout(() => {
    //     //console.log("1 count has been used");

    //     this.updateVideoDetails("count", 5);
    //   }, 5000 - this.state.duration);
    // }
    this.pollInterval = setInterval(() => {
      this.setState(
        (prevState) => {
          return {
            duration:
              prevState.currentTime - prevState.lastSeek + prevState.delta,
          };
        },
        () => {
          //console.log("Updating duration on server", this.state.duration, (Date.now()/1000)%100);
          //	 this.updateVideoDetails("view",this.state.duration)
        }
      );
    }, this.pollIntervalDuration());
  };

  componentWillUnmount() {
    this.playerClose();
  }

  playerClose = () => {
    var duration =
      this.state.currentTime - this.state.lastSeek + this.state.delta;

    // if (duration > 5) {
    //   //console.log("Updating duration on server", duration);

    //   this.updateVideoDetails("view", duration);
    //   !this.props.isExhaustedDisabled && this.props.getFolderContent();
    // }
    clearTimeout(this.startTimer);
    clearInterval(this.pollInterval);
  };
  onTime = (key) => {
    //const player = window.jwplayer(key);

    // this.player.currentTime() - this.state.currentTime;
    if (Math.abs(this.state.currentTime - this.player.currentTime()) > 5) {
      // this.setState({lastSeek: this.player.currentTime()});
      /*
      1. update the delta as delta += this.state.currentTime - this.state.lastSeek;
      */

      this.setState(
        {
          delta:
            this.state.delta +
            Math.abs(this.state.currentTime - this.state.lastSeek),

          lastSeek: this.player.currentTime(),
        },

        () => {
          this.setState({ currentTime: this.player.currentTime() });
        }
      );
    } else {
      this.setState({ currentTime: this.player.currentTime() });
    }

    //	console.log(this.state.currentTime,"currentTime");
    //	console.log(this.state.lastSeek,"lastSeek")
  };

  // onThreeSeconds = (key) => {
  // 	this.setState ({
  // 		viewsCount : this.state.viewsCount+1
  // 	})

  // }

  onReady = (key, player) => {
    const { item } = this.props;
    this.player = player;
  };

  exhaustCondition = () => {
    const { item, student } = this.props;

    if (item.isOwn && !student) {
      return false;
    } else if (
      student &&
      (this.state.duration - 9.9 < item.videoDurationAvailable / 1000 ||
        item.videoDurationAvailable == -1)
    ) {
      return false;
    } else return true;
  };

  getVideoLink = async (item, hashKey, that) => {
    console.log(this);
    that.setState({
      loading: true,
    });
    let data = await getJwpSignedUrl(item.vidKey, hashKey, item);

    that.setState({
      signedUrl: data?.url,
      loading: false,
      drmUrls:
        data?.drmUrls && Object.keys(data.drmUrls).length ? data.drmUrls : null,
    });
    // console.log('++++ITEM', item);
    // console.log('++++newSignedUrl', newSignedurl);
  };

  render() {
    const { item, student, isExhaustedDisabled } = this.props;
    const { loading, error, drmUrls } = this.state;
    const fileUrl = this.state.signedUrl ? this.state.signedUrl : item.url;

    return loading ? (
      this?.props?.t("src.components.ReactPlayer.Player.loading", "Loading...")
    ) : error ? (
      this?.state?.ERROR_MESSAGE
    ) : (
      <div className={styles.videoContainer}>
        <div className="rotttt">      {
          // !this.exhaustCondition() || isExhaustedDisabled ? (
          item.videoType == "jw-hosted" ? (
            <CPWebVideoJsPlayer
              options={{
                autoplay: true,
                controls: true,
                responsive: true,
                fluid: true,
                poster: item.thumbnailUrl,
                playbackRates: [0.5, 1, 1.25, 1.5, 2],
                sources: !drmUrls
                  ? [
                    {
                      src: fileUrl,
                      //   type: 'application/x-mpegURL'
                    },
                  ]
                  : undefined,
                aspectRatio: "16:9",
              }}
              drmUrls={drmUrls}
              watermark={item.watermarkUrl}
              onReady={(player) => this.onReady(item.vidKey, player)}
              onPlay={(evt) => this.onPlay(item.vidKey)}
              onPause={(evt) => this.onPause(item.vidKey)}
              onTimeUpdate={(evt) => this.onTime(item.vidKey)}
              onResume={(evt) => this.onResume(item)}
              onEnded={(evt) => this.onOneHundredPercent(item.vidKey)}
            />
          ) : (
            <CPWebVideoJsPlayer
              options={{
                autoplay: true,
                controls: true,
                responsive: true,
                fluid: true,
                poster: item.thumbnailUrl,
                playbackRates: [0.5, 1, 1.25, 1.5, 2],
                sources: !drmUrls
                  ? [
                    {
                      src: fileUrl,
                      //   type: 'application/x-mpegURL'
                    },
                  ]
                  : undefined,
                aspectRatio: "16:9",
              }}
              drmUrls={drmUrls}
              watermark={item.watermarkUrl}
              onReady={(player) => this.onReady(item.vidKey, player)}
              onPlay={(evt) => this.onPlay(item.vidKey)}
              onPause={(evt) => this.onPause(item.vidKey)}
              onTimeUpdate={(evt) => this.onTime(item.vidKey)}
              onResume={(evt) => this.onResume(item.vidKey)}
            />
          )
          // ) : (
          //   this.props.handleOpenWatchExhaustedModal()
          // )}
        }</div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    hashKey: state?.infoReducer?.tutorToken,
  };
}

export default connect(mapStateToProps)(withTranslation()(Player));
